module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc2-02-8484ae15ed4ebf5b75f51532c7b7ebcc.png";